var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.6 34.3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.8.7c9.278 0 16.8 7.522 16.8 16.8s-7.522 16.8-16.8 16.8S0 26.778 0 17.5 7.522.7 16.8.7m0 2.013c-8.166 0-14.787 6.62-14.787 14.787 0 8.166 6.62 14.787 14.787 14.787 8.166 0 14.787-6.62 14.787-14.787 0-8.166-6.62-14.787-14.787-14.787m.21 21.087a1.89 1.89 0 1 1 0 3.78 1.89 1.89 0 0 1 0-3.78m0-16.8c.57 0 1.033.426 1.05.957v12.337c0 .545-.47.986-1.05.986-.57 0-1.033-.426-1.05-.957V7.986c0-.545.47-.986 1.05-.986"
  })));
};
export default SvgWarning;